export const getIsPublicRead = (arrayList, toCheck) => {
  return arrayList?.find(
    e => e?.value == toCheck || e?.id == toCheck || e == toCheck
  );
};
